export default __webpack_public_path__ + "static/media/thersher-icon.14d0f1f9.svg";